import { render, staticRenderFns } from "./DisclosureLinks.vue?vue&type=template&id=31b1e3f4"
import script from "./DisclosureLinks.vue?vue&type=script&lang=ts"
export * from "./DisclosureLinks.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports